import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../../utils/config';

const CategoryCard = ({ 
  category, 
  isAdmin = false, 
  onEdit = null, 
  onDelete = null,
  storeSlug = null 
}) => {
  const handleEdit = (e) => {
    e.preventDefault();
    if (onEdit) onEdit(category);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    if (onDelete) onDelete(category);
  };

  const cardContent = (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-shadow p-6">
      {/* Category Icon */}
      <div className="flex items-center justify-center mb-4">
        {category.icon ? (
          <img
            src={getImageUrl(category.icon)}
            alt={`${category.name} icon`}
            className="w-16 h-16 rounded-lg object-cover border border-gray-200"
            onError={e => {
              e.target.onerror = null;
              e.target.style.display = 'none';
              e.target.parentNode.innerHTML = `<div class="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center"><span class="text-gray-400 text-2xl">📁</span></div>`;
            }}
          />
        ) : (
          <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center">
            <span className="text-gray-400 text-2xl">📁</span>
          </div>
        )}
      </div>

      {/* Category Info */}
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {category.name}
        </h3>
        {category.description && (
          <p className="text-sm text-gray-600 mb-3 line-clamp-2">
            {category.description}
          </p>
        )}
        
        {/* Product Count */}
        {category.products_count !== undefined && (
          <p className="text-xs text-gray-500">
            {category.products_count} product{category.products_count !== 1 ? 's' : ''}
          </p>
        )}
      </div>

      {/* Admin Actions */}
      {isAdmin && (
        <div className="mt-4 pt-4 border-t border-gray-100">
          <div className="flex gap-2">
            <button
              onClick={handleEdit}
              className="flex-1 px-3 py-2 text-sm text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors"
            >
              Edit
            </button>
            <button
              onClick={handleDelete}
              className="flex-1 px-3 py-2 text-sm text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors"
            >
              Delete
            </button>
          </div>
        </div>
      )}
    </div>
  );

  // If it's a public view and we have a store slug, make it clickable
  if (!isAdmin && storeSlug) {
    return (
      <Link 
        to={`/stores/${storeSlug}/categories/${category.id}`}
        className="block hover:no-underline"
      >
        {cardContent}
      </Link>
    );
  }

  return cardContent;
};

export default CategoryCard; 